import { IRouteConfigsOpts } from 'Src/ng2/routing/route.config';
import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';
export const rootRoute: IRouteConfigsOpts = {
  path: '',
  pathMatch: 'full',
  url: '/',
  authenticationRequired: false,
  rolePermissions: ['all'],
  redirectTo: '/district-picker',
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
};
